import { ChangeDetectionStrategy, Component } from '@angular/core'
import { MatDialogModule } from '@angular/material/dialog'
import { TranslateModule } from '@ngx-translate/core'
import { MatButtonModule } from '@angular/material/button'

@Component({
  selector: 'gb-conclude-raffle-dialog',
  standalone: true,
  imports: [TranslateModule, MatDialogModule, MatButtonModule],
  templateUrl: './gb-conclude-raffle-dialog.component.html',
  styleUrl: './gb-conclude-raffle-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GbConcludeRaffleDialogComponent {}
